import { LOGOUT_RTK } from "@/components/access/ducks/Actions"
import { createSlice } from "@reduxjs/toolkit"
import { deleteClassNoteThunk, exportClassNotesThunk, fetchClassNotesThunk } from "./thunks"

/** @typedef {import("./thunks").ConstituentClassNote} ConstituentClassNote */

/**
 * @typedef {Object} ClassNotesAdminState
 * @property {boolean} classNotesFetched
 * @property {Array<ConstituentClassNote>} constituentClassNotes
 */

/** @type {ClassNotesAdminState} */
const initialState = {
  classNotesFetched: false,
  constituentClassNotes: [],
}

const classNotesAdminSlice = createSlice({
  name: "classNote/admin",
  initialState,
  reducers: {
    receiveClassNotes(state, action) {
      state.constituentClassNotes = action.payload
      state.classNotesFetched = true
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(LOGOUT_RTK, (_state, _action) => initialState)
      .addCase(fetchClassNotesThunk.fulfilled, (state, action) => {
        state.constituentClassNotes = action.payload
        state.classNotesFetched = true
      })
      .addCase(deleteClassNoteThunk.fulfilled, (state, action) => {
        state.constituentClassNotes = action.payload
        state.classNotesFetched = true
      })
  },
})

export const ClassNoteAdminActions = {
  ...classNotesAdminSlice.actions,
  fetchClassNotes: fetchClassNotesThunk,
  exportClassNotes: exportClassNotesThunk,
  deleteClassNote: deleteClassNoteThunk,
}

export default classNotesAdminSlice.reducer
